import { baseUrl } from "src/utils/url-utils";
import { OpenAPIConfig, OpenAPI as OpenAPIV1 } from "./openapi/v1";
import { hasValueAndNotEmpty } from "@itk/typescript-utils";
import { itkComponentsButtonActions, setOverlayedFetchConfig } from "@itk/mui-components";
import { Store } from "redux";
import { store } from "src/store";

export const setAccessToken = (accessToken: string) => {
  localStorage.setItem("deko-access-token", accessToken);
  configureOpenApis();
};

export const getAccessToken = () => {
  const state = store.getState();

  const tokenLoading = state.generalReducer.authorizationGateReducer.authorizationGateState;
  if (tokenLoading.loading === "has-loaded") {
    return tokenLoading.data.access_token;
  }

  const accessToken = localStorage.getItem("deko-access-token");

  if (hasValueAndNotEmpty(accessToken)) {
    deleteAccessToken();
  }

  return accessToken ?? "";
};

export const deleteAccessToken = () => {
  localStorage.removeItem("deko-access-token");
};

const configureOpenApi = (openApi: OpenAPIConfig) => {
  openApi.BASE = baseUrl as string;
  openApi.TOKEN = async () => getAccessToken();
};

export const configureOpenApis = () => {
  configureOpenApi(OpenAPIV1);
};

export const configureUiBlock = (store: Store) => {
  const beforeCallAction = (url: string, reject?: (error?: string) => void) => store.dispatch(itkComponentsButtonActions.addOngoingCall(url, reject));
  const afterCallAction = (url: string) => store.dispatch(itkComponentsButtonActions.removeOngoingCall(url));

  OpenAPIV1.BEFORE_CALL_ACTION = beforeCallAction;
  OpenAPIV1.AFTER_CALL_ACTION = afterCallAction;

  setOverlayedFetchConfig({ beforeCallAction, afterCallAction });
};
